import type { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { onboardingSchema } from '@/features/onboarding/constants/onboarding.schema';

export const ONBOARDING_STEPS = [
  'stats',
  'favourite-agent',
  'servers',
  'display-name',
  'age',
  'languages',
  'mode-selection',
  'notifications',
  'game-mode-preference',
  'voice-chat-participation',
  'in-game-comm-style',
  'personality-traits',
  'nearly-done',
  'play-schedule',
  'bonding-pace',
  'pre-game-routine',
  'non-toxic',
] as const;

export type OnboardingDataInput = z.input<typeof onboardingSchema>;
export type OnboardingDataOutput = z.output<typeof onboardingSchema>;
export type OnboardingData = z.input<typeof onboardingSchema>;

export type OnboardingStep = (typeof ONBOARDING_STEPS)[number];

export type OnboardingDoneMap = Record<OnboardingStep, boolean>;

export type DefaultOnboardingData = DefaultValues<OnboardingData>;
